import React from 'react'

export const H2HSidebarIcon = ({ isActive }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.401 10.5391C12.401 10.5391 12.3257 16.2752 16.5285 16.5289C20.7304 16.7808 22.4008 12.2875 22.4008 12.2875C22.4008 12.2875 12.926 10.9618 12.401 10.5391Z"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.6497 7C1.6497 7 9.48624 7.39073 12.9302 7C12.9302 7 10.1986 14.6142 15.3643 16.826C15.3643 16.826 12.2768 17.2174 9.60466 16.826C6.93317 16.4353 0.99563 14.9397 1.6497 7Z"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
      strokeWidth="1.5"
    />
  </svg>
)
